import React, { useState, useRef, useEffect } from "react";
import s from "../TrainingProgram.module.css";
import { useParams } from "react-router-dom";
import { useAppTranslation } from "./TranslationContext";
import { useAuth } from "../context/AuthContext";

export const TrainingProgram = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const refs = useRef([]);
  const [themes, setThemes] = useState([]);
  const [duration, setDuration] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { handleLang } = useAuth();
  const { t } = useAppTranslation();
  const { id } = useParams();

  const toggleSpoiler = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    if (openIndex !== null) {
      const el = refs.current[openIndex];
      if (el) {
        el.style.maxHeight = el.scrollHeight + "px";
      }
    }
    refs.current.forEach((el, i) => {
      if (el && i !== openIndex) {
        el.style.maxHeight = "0px";
      }
    });
  }, [openIndex]);

  useEffect(() => {
    fetch(`https://api.eduskill.uz/api/kurs-mavzulari/?kurs=${id}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Ошибка сети: " + response.status);
        }
        return response.json();
      })
      .then((json) => {
        const mappedThemes = json.map((i) => ({
          id: i.id,
          kurs_id: i.kurs.id,
          title_uz: i.nomi_uz,
          title_ru: i.nomi_ru,
          title_en: i.nomi_en,
          image: i.mrasmi_uz,
          desc_uz: i.short_text_uz,
          desc_ru: i.short_text_ru,
          desc_en: i.short_text_en,
          keyWords_uz: i.key_word_uz,
          keyWords_ru: i.key_word_ru,
          keyWords_en: i.key_word_en,
        }));
        setThemes(mappedThemes);
        if (json.length > 0) {
          setDuration(json[0].kurs.davomiyligi);
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p className="container">{t("loading")}</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className={s.training}>
      <p className={s.trainingTitle}>{t("programTitle")}</p>
      
      <div className={s.spoilers}>
        {themes.map((block, index) => (
          <div
            key={block.id}
            className={`${s.spoiler} ${
              index === 0 ? s.start : ""
            } ${index === themes.length - 1 ? s.end : ""}`}
            onClick={() => toggleSpoiler(index)}
          >
            <div className={s.spoilerContents}>
              <p className={s.spoilerTitle}>
                {handleLang(block.title_uz, block.title_ru, block.title_en)}
              </p>
              <p className={s.spoilerText}>
                {handleLang(block.desc_uz, block.desc_ru, block.desc_en)}
              </p>
              <ul
                className={s.spoilerUl}
                ref={(el) => (refs.current[index] = el)}
              >
                <li>
                  {handleLang(
                    block.keyWords_uz,
                    block.keyWords_ru,
                    block.keyWords_en
                  )}
                </li>
              </ul>
            </div>
            <span
              className={`${s.materialTop} material-symbols-outlined`}
              style={{
                transform:
                  openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease-in-out",
              }}
            >
              <img
                className={s.spoiler__button__next}
                alt="next"
                src="https://cdn-icons-png.flaticon.com/128/130/130882.png"
              />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
